import React from 'react';
import Classes from 'classnames';
import Popover from '../../../../core/gd-components/gd-popover/popover';
import {findDOMNode} from "react-dom";
import PinPopoverMenuItem from "../../../../core/gd-components/pin/pin-popover-menu-item";
import ControlButtonStandard, {ControlButtonType} from "../../../../core/gd-components/buttons/control-button/control-button-standard";
import {ControlButtonSize} from "../../../../core/gd-components/buttons/control-button/@types";
import {PinTask} from "../../../../core/model2/pin/@types";

type Props = {
    task        : PinTask
    className?  : string
}

type State = {
    showPopover: boolean
}

export default class NavigationMenuItemTaskMore extends React.Component<Props, State> {

    constructor(props: Props) {
        super(props);

        this.state = {
            showPopover: false
        };
    }

    showPopover = (e: React.SyntheticEvent) => {
        e.stopPropagation();
        if (!this.state.showPopover) this.setState({showPopover: true})
    };

    hidePopover = () => {
        if (this.state.showPopover) this.setState({showPopover: false})
    };

    renderPopover() {

        return (
            <Popover popoverClass="ui-menu-more-popover"
                     constraints={[{
                         to: 'window',
                         attachment: 'together',
                         // to: 'scrollParent',
                         pin: true
                     }]}
                     attachment="top left"
                     targetAttachment="top right"
                     attachmentType="vertical"
                     offset="3 0"
                     getTargetFunc={()=>findDOMNode(this)}
                     onClickOutside={()=>{this.hidePopover()}}>

                <div className="ui5-popover-menu min-w-225">
                    <PinPopoverMenuItem data={{taskId: this.props.task.id}} />
                </div>

            </Popover>
        );
    }


    render() {

        const moreButton = Classes("more", {
            'popover-shown'         : this.state.showPopover
        })

        return (
            <ControlButtonStandard className    = {moreButton}
                                   type         = {ControlButtonType.MORE}
                                   size         = {ControlButtonSize.SIZE_24}
                                   onClick      = {this.showPopover}>
                {this.state.showPopover && this.renderPopover()}
            </ControlButtonStandard>
        );
    }
}
